import { createI18n } from 'vue-i18n'
import { mapValues } from 'lodash'

// The locale files are also read by Rails (config/initializers/i18n_backend.rb), so they keep the
// Rails "%{name}" placeholders; vue-i18n 9+ only understands "{name}".
function toVueI18nSyntax (message) {
  if (typeof message === 'string') {
    return message.replace(/%\{(\w+)\}/g, '{$1}')
  }
  return mapValues(message, toVueI18nSyntax)
}

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = toVueI18nSyntax(locales(key))
    }
  })
  return messages
}

const dateTimeFormats = {
  'en': {
    short: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false
    }
  },
  'ja': {
    short: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false
    }
  }
}

const numberFormats = {
  'en': {
    number: {
      style: 'decimal'
    }
  },
  'ja': {
    number: {
      style: 'decimal'
    }
  }
}

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: process.env.VUE_APP_I18N_LOCALE || 'ja',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ja',
  messages: loadLocaleMessages(),
  datetimeFormats: dateTimeFormats,
  numberFormats
})
